import { render, staticRenderFns } from "./VBarrage.vue?vue&type=template&id=d7729c1e&"
import script from "./VBarrage.vue?vue&type=script&lang=js&"
export * from "./VBarrage.vue?vue&type=script&lang=js&"
import style0 from "./VBarrage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports